module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter3"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch3"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("HOT AND SWEET CHILI WINGS, ASIAN STYLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Enjoy the balance of the sweet and tart flavors of these delicious wings to set the mood for an Asian dinner. Sweet Asian chili sauce can be found in the Asian department in most supermarkets. Provide napkins, as these are sticky.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("3 pounds chicken wings (about 12)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup sweet Asian chili sauce, plus extra for dipping")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon peeled, grated fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon honey")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon fresh lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 garlic cloves, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Cut off the wing tips with kitchen scissors or a sharp knife and discard or save them for stock. Halve the wings at the joint and trim excess fat and skin. In a large bowl, mix together the remaining ingredients. Add the wings and stir to coat. Cover and refrigerate several hours, stirring once.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Preheat the oven to 375°F. Line a baking sheet with foil. Remove the wings from the marinade and boil the marinade for 1 minute. Place the wings on the baking sheet in a single layer. Bake for 15 minutes. Brush with the boiled marinade and continue to bake until cooked through, about 20 minutes longer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes 24 pieces")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d5d5b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011-chapter3.vue
// module id = 87
// module chunks = 0